import Carousel from 'react-bootstrap/Carousel';
import React, {useEffect, useState} from 'react';
import { Firebase } from '../components/config';
import '../cssfiles/banner.css'
import Spinner from '../components/spinner';
function banner() {
    const [ban, setBan]= useState([])
    const [first, setFirst] = useState()
useEffect(() => {
  Firebase.firestore().collection('banner').get().then((snapshot)=>{
    snapshot.forEach((obj)=>{

    setBan(obj.data().poster)
setFirst(obj.data().poster)
    }) 
  })
}, [])


    return (
      <Carousel >
        <Carousel.Item interval={500} >
         { first  ?  <img
          className="d-block w-100 banner"
          src={ban[0]}
          alt="PRODUCT"
        /> : <div className="loader"><Spinner /></div>} 
       
        </Carousel.Item>
        <Carousel.Item interval={500}>
        { first  ?  <img
          className="d-block w-100 banner"
          src={ban[1]}
          alt="PRODUCT"
        /> : <div className="loader"><Spinner /></div>} 
         
        </Carousel.Item>
        <Carousel.Item interval={500}>
        { first  ?  <img
          className="d-block w-100 banner"
          src={ban[2]}
          alt="PRODUCT"
        /> : <div className="loader"><Spinner /></div>} 
          
          
        </Carousel.Item>
      </Carousel>
    );
  }
  
  export default banner;
